package com.milta.core.localization.translations.en

import com.milta.core.localization.AdminOcrAnalysisStrings

internal val AdminOcrAnalysis = AdminOcrAnalysisStrings(
    loading = "Loading…",
    errorNoConnection = "Unable to reach the server — check your connection.",
    errorGeneric = "Something went wrong. Please try again later.",
    emptyStateMessage = "No data yet.",
    kpiTotalDocumentsLabel = "Documents analyzed",
    kpiCompletedDocumentsLabel = "Completed documents",
    kpiCompletedDocumentsSubtitle = "simulated across the 4 strategies",
    kpiTotalRealCostLabel = "Total real cost",
    kpiTotalInputTokensLabel = "Input tokens",
    kpiTotalOutputTokensLabel = "Output tokens",
    breakdownByFileKindLabel = "Breakdown",
    fileKindImageLabel = "Images",
    fileKindPdfLabel = "PDFs",
    fileKindXlsxLabel = "Spreadsheets",
    flowTitle = "The complete flow, step by step",
    flowYesLabel = "Yes",
    flowNoLabel = "No",
    flowStep1Title = "Document sent",
    flowStep1Subtitle = "Photo, PDF, or file received via the app",
    flowStep2Title = "Unique fingerprint computed",
    flowStep2Subtitle = "A unique identifier is computed for this document",
    flowStep2Note = "If already seen: local analysis is not redone (the real AI cost is still counted normally, since it's a real upload).",
    flowStep3Title = "File type detected",
    flowStep3Subtitle = "The rest of the analysis differs depending on the type",
    flowImageBranchTitle = "📷 If it's a photo",
    flowImageStep1Title = "Quality check",
    flowImageStep1Subtitle = "Sharpness, brightness, resolution, document well framed",
    flowImageStep2Title = "If quality is judged insufficient",
    flowImageStep2Subtitle = "The reason is logged, but local reading is still attempted right after",
    flowImageStep3Title = "Skew correction",
    flowImageStep3Subtitle = "The image is straightened if a reliable tilt is detected",
    flowImageStep4Title = "Local reading (free)",
    flowImageStep4Subtitle = "Text reading without AI — French, Dutch, English",
    flowImageStep5Title = "Reliability score",
    flowImageStep5Subtitle = "Score from 0 to 100 on the quality of this local reading",
    flowPdfBranchTitle = "📄 If it's a PDF",
    flowPdfStep1Title = "Native text detected?",
    flowPdfStep1Subtitle = "Checks whether the PDF already contains usable digital text",
    flowPdfNote = "If scanned with no native text: each page (up to 20) is rendered to an image and re-read locally, same as a photo.",
    flowXlsxBranchTitle = "📊 If it's a spreadsheet",
    flowXlsxStep1Title = "Columns identified",
    flowXlsxStep1Subtitle = "Automatic, or AI-assisted, recognition of columns (name, address, phone…)",
    flowXlsxNote = "File structure (rows, columns, header) analyzed locally.",
    flowClaudeTitle = "AI call (Claude)",
    flowClaudeSubtitle = "A real call is always made today, regardless of the path above — real cost charged",
    flowSimulationTitle = "🔬 After-the-fact simulation (not in production)",
    flowSimulationNote = "Once the data above has been collected, 4 alternative strategies are replayed over these same documents to estimate what they would have cost instead of the systematic AI call — that's exactly what the table below compares. None of these 4 strategies is actually used in production today.",
    flowPersistTitle = "Saved",
    flowPersistSubtitle = "The real result and the 4 simulations are stored",
    flowDashboardTitle = "Dashboard",
    flowDashboardSubtitle = "This screen aggregates the results per strategy",
    tableTitle = "Comparison of possible strategies",
    columnMode = "Strategy",
    columnDocuments = "Documents",
    columnClaudeCalls = "AI calls",
    columnProjectedCost = "Projected cost",
    columnRealCost = "Real cost",
    columnSavings = "Projected savings",
    modeBaseline = "Current strategy",
    modeBaselineDescription = "The AI is called systematically for every document — this is what's actually used in production today.",
    modeMinimal = "Light preprocessing",
    modeMinimalDescription = "Small optimizations before sending to the AI, without changing the decision: the AI is always called, same cost as the current strategy.",
    modeTesseractGate = "Local reading with AI fallback",
    modeTesseractGateDescription = "A free local reading first assesses the document's quality; the AI is only called if that reading is judged insufficient.",
    modeTesseractOnly = "Local reading only",
    modeTesseractOnlyDescription = "No AI call at all — only a free local reading, potentially less reliable on poor-quality documents.",
)
